"use client";

import React from "react";
import { Video, Layers, Plane } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const specialties = [{
  title: "Création d'Annonces",
  description: "Optimisation de votre visibilité avec des photographies professionnelles et une rédaction stratégique sur les plateformes majeures.",
  icon: Video,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628541/img/service_video_cinematic.png"
}, {
  title: "Ménage Professionnel",
  description: "Un entretien rigoureux et des standards hôteliers pour garantir une propreté irréprochable à chaque nouvelle arrivée.",
  icon: Layers,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628541/img/immaculate_apartment_cleaning_service.png"
}, {
  title: "Accueil Voyageurs",
  description: "Une gestion personnalisée des arrivées et départs, incluant remise des clés et conseils locaux pour un séjour inoubliable.",
  icon: Plane,
  bgImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628541/img/warm_friendly_home_concierge_welcome.png"
}];
export default function OurVisualSpecialties() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="74629" id="nos-prestations-signature" className="bg-background text-foreground py-24 md:py-32 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 md:mb-24 text-center md:text-left">
          <h2 className="font-default text-5xl md:text-7xl tracking-wider uppercase text-foreground mb-6">
            Nos Prestations <span className="text-accent">Signature</span>
          </h2>
          <p className="font-default text-muted-foreground text-lg md:text-xl max-w-2xl leading-relaxed">
            Une gestion complète et haut de gamme pour vos propriétés sur la Côte d’Azur. Nous maximisons vos revenus tout en offrant une expérience d'exception à vos voyageurs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {specialties.map((specialty, i) => {
          const Icon = specialty.icon;
          return <div key={i} data-index={i} className="group relative h-[400px] md:h-[500px] rounded-lg overflow-hidden bg-card border border-border/30 transition-all duration-700 ease-in-out hover:scale-[1.02] hover:shadow-2xl hover:shadow-accent/10 cursor-pointer">
                {}
                <div className="absolute inset-0 bg-cover bg-center opacity-0 group-hover:opacity-100 transition-all duration-1000 ease-in-out scale-105 group-hover:scale-100" style={{
              backgroundImage: `url(${specialty.bgImage})`
            }} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-background/20 opacity-100 group-hover:opacity-90 transition-opacity duration-700" />
                
                {}
                <div className="relative z-10 flex flex-col h-full p-8 md:p-10 justify-end">
                  <div className="mb-auto transform transition-transform duration-700 ease-in-out group-hover:-translate-y-2">
                    <Icon className="size-10 text-accent stroke-[1.5]" />
                  </div>
                  
                  <div className="transform transition-transform duration-700 ease-in-out group-hover:translate-y-0 translate-y-4">
                    <h3 className="font-default text-3xl md:text-4xl tracking-wider text-foreground mb-4 uppercase">
                      {specialty.title}
                    </h3>
                    <p className="font-default text-muted-foreground group-hover:text-foreground/90 transition-colors duration-500 leading-relaxed">
                      {specialty.description}
                    </p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}